import { api } from '../client';
import type { Position } from '../types';

interface ListParams {
  deviceId?: number;
  /** ISO 8601, ex: "2026-05-09T00:00:00Z" */
  from?: string;
  /** ISO 8601 */
  to?: string;
  id?: number | number[];
}

export const positionsApi = {
  /**
   * Sem parâmetros, retorna a última posição conhecida de cada dispositivo do
   * usuário. Para histórico de um dispositivo, passe deviceId, from e to.
   * Para feed contínuo, prefira o WebSocket em vez de polling.
   */
  list: (params?: ListParams) => api.get<Position[]>('/positions', { query: params }),
};
